import 'uni-pages';import 'uni-h5';import Vue from 'vue'
import store from './store'
import App from './App'

import * as filters from './filters'

import config from './config'

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


  /**
   * 微信H5字体缩放处理
   * 仅在微信H5环境中执行，阻止字体放大影响布局
   * 其他浏览器完全跳过，不会报错
   */
  ; (function () {
    // 先检查基本环境是否存在
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
      return
    }

    try {
      // 检测是否在微信H5环境
      const ua = navigator.userAgent || ''
      const uaLower = ua.toLowerCase()
      const isWechat = uaLower.indexOf('micromessenger') > -1

      // 只有在微信环境下才执行
      if (!isWechat) {
        return
      }

      // 设置字体大小不被微信调整
      const handleFontSize = function () {
        try {
          // 确保 WeixinJSBridge 存在且可调用
          if (window.WeixinJSBridge && typeof window.WeixinJSBridge.invoke === 'function') {
            window.WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 })
          }
        } catch (e) {
          // 静默处理错误
        }
      }

      // 检查 WeixinJSBridge 是否已就绪
      if (window.WeixinJSBridge && typeof window.WeixinJSBridge.invoke === 'function') {
        handleFontSize()
      } else if (typeof document !== 'undefined') {
        document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
      }
    } catch (e) {
      // 非微信环境或执行出错，静默忽略
    }
  })()











// 判断当前是否是微信浏览器
const boolForWeChatH5 = () => {

  const ua = navigator.userAgent.toLowerCase()
  if (ua.indexOf('micromessenger') !== -1) {
    return true
  }

  return false
}


if (boolForWeChatH5()) {
  const jweixin = require('./components/jweixin-module')
  const jwx = require('./components/jweixin-module/jwx')
  Vue.prototype.$jweixin = jweixin
  Vue.prototype.$jwx = jwx
  Vue.mixin({
    onShow() {
      // jwx.configWeiXin(jwx => {
      //   console.log(jwx)
      // })
    }
  })
}


/**
 * 获取真实的URL
 * 有code的时候要去除微信的code参数
 */
const getRealUrl = (url = window.location.href) => {
  url = url.split('?')
  if (url.length > 1 && url[1].indexOf('code=') !== -1) {
    if (url[1].indexOf('#') !== -1) {
      var temp = url[1].split('#')
      url[0] += '#' + temp[1]
    }
    url.splice(1, 1)
  }
  return url.join('?')
}

const getWechatUserAuth = function (code) {
  const url = getRealUrl();
  const _url = encodeURIComponent(url);
  console.log('_url==', _url)
  if (!code) {
    // code为空，跳转到授权页面
    console.log('appid', config.h5Appid)
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.h5Appid}&redirect_uri=${_url}&response_type=code&scope=snsapi_userinfo&forcePopup=false&forceSnapShot=false&state=STATE#wechat_redirect`
    return;
  }
  return new Promise((resolve, reject) => {
    uni.request({
      url: config.baseUrl + '/common/wechat/getWechatUserAuth',
      data: {
        code: code
      },
      method: 'POST',
      header: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      success: (res) => {
        console.log('res====', res)
        if (res.statusCode === 200) {
          const _data = res.data;
          if (_data.code === 200) {
            resolve(_data)
          } else if (_data.code === 101) {
            // 获取失败，重新发起授权
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.h5Appid}&redirect_uri=${_url}&response_type=code&scope=snsapi_userinfo&forcePopup=false&forceSnapShot=false&state=STATE#wechat_redirect`
            reject(_data)
          } else {
            reject(_data)
          }
        } else {
          reject({ code: res.statusCode, msg: '请求失败' })
        }
      },
      fail: (err) => {
        reject({ code: -1, msg: '网络不可用' })
      }
    })
  })
}

const msg = (title, duration = 1500, mask = false, icon = 'none') => {
  // 统一提示方便全局修改
  if (Boolean(title) === false) {
    return
  }
  uni.showToast({
    title,
    duration,
    mask,
    icon
  })
}

let userInfo

// 防止多个并发请求 401 时反复弹登录过期提示
let isLoginExpiredModalShown = false
// 防止多个并发请求 401 时重复发起静默重登
let isReloginPending = false

const logout = () => {
  userInfo = undefined
  uni.removeStorage({
    key: 'userInfo'
  })
}

const setUserInfo = (i) => {
  userInfo = i
}

const isVip = () => {
  return userInfo && userInfo.level
}

const isAgent = () => {
  return userInfo && userInfo.isAgent === 1
}

// 定义不需要登录的接口地址
const notLoginUrlList = ['/captchaImage', '/common/getServiceCode', '/common/config/mall.memberAgreement', '/common/config/mall.privacyAgreement', '/cms/article/category/list', '/cms/article/list', '/cms/article/detail', '/cms/faq/list'];

// 登录提示弹窗（可取消，不再强制跳转登录页）
const showLoginExpiredModal = (content = '登录状态已过期，请重新登录') => {
  if (!isLoginExpiredModalShown) {
    isLoginExpiredModalShown = true
    uni.showModal({
      title: '提示',
      content,
      confirmText: '去登录',
      cancelText: '取消',
      success: (res) => {
        if (res.confirm) {
          uni.navigateTo({
            url: '/pages/public/login'
          })
        }
      },
      complete: () => {
        isLoginExpiredModalShown = false
      }
    })
  }
}

// 静默补全用户信息：静默重登成功后调用，失败不提示
const syncUserInfoSilently = () => {
  const token = userInfo ? userInfo.accessToken : ''
  uni.request({
    url: config.baseUrl + '/getInfo',
    method: 'GET',
    header: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'Bearer ' + token
    },
    success: (res) => {
      if (res.statusCode === 200 && res.data && res.data.code === 200 && res.data.data) {
        const stored = { ...(uni.getStorageSync('userInfo') || {}), ...res.data.data }
        uni.setStorageSync('userInfo', stored)
        userInfo = stored
      }
    },
    fail: () => { }
  })
}

// 401 后静默重登（仅微信小程序端）：uni.login 换新 code 重新登录，
// 成功后更新本地 token 并顺带补全用户信息，用户无感知恢复登录态。
const silentRelogin = () => {
















































  return Promise.resolve(false)

}

const doRequest = (url, data, methods, failCallback, resolve, reject, isRetry) => {
  if (!userInfo || !userInfo.accessToken) {
    userInfo = uni.getStorageSync('userInfo')
  }
  let _header = { 'Content-Type': 'application/json;charset=UTF-8' };
  const accessToken = userInfo ? userInfo.accessToken : ''
  if (notLoginUrlList.indexOf(url) === -1) {
    _header['Authorization'] = 'Bearer ' + accessToken;
  }
  const baseUrl = config.baseUrl
  uni.request({
    url: baseUrl + url,
    data: {
      ...data,
    },
    method: methods,
    header: _header,
    success: (res) => {
      if (res.statusCode === 200) {
        if (res.data.code === 200) {
          resolve(res.data)
        } else if (res.data.code === 401) {
          if (failCallback && !isRetry) {
            failCallback(res.data)
          }
          uni.hideLoading();
          // 本地有 token（登录过）：保留本地登录态，先尝试微信静默重登并重放请求，
          // 静默重登成功则用户无感知恢复登录；失败才提示
          if (!isRetry && userInfo && userInfo.accessToken) {
            silentRelogin().then((ok) => {
              if (ok) {
                // 换到新 token 后重放一次原请求
                doRequest(url, data, methods, failCallback, resolve, reject, true)
              } else {
                showLoginExpiredModal()
              }
            })
          } else {
            // 未登录（本地无 token）或重放后仍 401：提示登录
            showLoginExpiredModal(userInfo && userInfo.accessToken ? '登录状态已过期，请重新登录' : '请先登录后使用')
          }
        } else {
          if (failCallback) {
            failCallback(res.data)
          } else {
            uni.showToast({
              title: res.data.msg,
              icon: 'none'
            })
          }
          // reject(res.data)
        }
      } else {
        reject({ code: res.statusCode, msg: '请求失败' })
      }
    },
    fail: (err) => {
      uni.hideLoading();
      uni.showToast({
        title: '网络不可用，请检查网络连接',
        icon: 'none',
        duration: 2000
      })
      if (failCallback) {
        failCallback({ code: -1, msg: '网络不可用' })
      }
      reject({ code: -1, msg: '网络不可用' })
    }
  })
}

// 异步请求数据（401 时自动静默重登并重放一次）
const request = (url, data = {}, methods = 'GET', failCallback) => {
  return new Promise((resolve, reject) => {
    doRequest(url, data, methods, failCallback, resolve, reject, false)
  })
}

const uploadImg = (url, successCallback) => {
  if (!userInfo || !userInfo.accessToken) {
    userInfo = uni.getStorageSync('userInfo')
  }
  const accessToken = userInfo ? userInfo.accessToken : ''
  const baseUrl = config.baseUrl
  const doUpload = (filePath) => {
    uni.showLoading({
      title: '图片上传中'
    })
    const fileName = ('imgs/' + random_string(15) + get_suffix(filePath))
    uni.uploadFile({
      url: baseUrl + url,
      filePath: filePath,
      name: 'file',
      formData: {
        url: filePath,
        fileName: fileName
      },
      header: {



        'Authorization': 'Bearer ' + accessToken
      },
      success: function (uploadRes) {
        uni.hideLoading()
        console.log(uploadRes)
        if (uploadRes.statusCode === 200) {
          const res = JSON.parse(uploadRes.data)
          if (res.code === 200) {
            console.log(successCallback)
            if (successCallback) {
              successCallback(res.data)
            } else {
              uni.showToast({
                title: '上传成功',
                icon: 'none'
              })
            }
          } else {
            uni.showToast({
              title: res.msg || '上传失败',
              icon: 'none'
            })
          }
        } else {
          uni.hideLoading()
          uni.showToast({
            title: '网络错误 code=' + uploadRes.statusCode,
            icon: 'none'
          })
        }
      },
      fail: function (err) {
        uni.hideLoading()
        uni.showToast({
          title: '上传失败，请重试',
          icon: 'none'
        })
      }
    })
  }
  uni.chooseImage({
    sizeType: ['compressed'],
    success: function (res) {
      for (let i = 0; i < res.tempFilePaths.length; i++) {
        doUpload(res.tempFilePaths[i])
      }
    }
  })
}

function get_suffix(filename) {
  const pos = filename.lastIndexOf('.')
  let suffix = ''
  if (pos !== -1) {
    suffix = filename.substring(pos)
  }
  return suffix
}

function random_string(len) {
  len = len || 32
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

const prePage = () => {
  const pages = getCurrentPages()
  const prePage = pages[pages.length - 2]
  if (!prePage) {
    return null
  }
  let res = prePage.$vm

  res = prePage

  return res
}

const globalData = {}

export function style(width) {
  if (config.OSS_PROVIDER === 'aliyun') {
    return '?x-oss-process=style/' + width + 'px'
  } else if (config.OSS_PROVIDER === 'qcloud') {
    return '?imageMogr2/thumbnail/' + width + 'x/interlace/0'
  }
}

Vue.config.productionTip = false
Vue.config.errorHandler = function (err, vm, info) {
  var detail = '[Vue Error] ' + (err && err.message ? err.message : String(err)) + '\nInfo: ' + (info || '')
  if (err && err.stack) detail += '\nStack: ' + err.stack
  console.error(detail)
}
Vue.prototype.$fire = new Vue()
Vue.prototype.$store = store
Vue.prototype.$api = {
  msg,
  prePage,
  request,
  uploadImg,
  logout,
  isVip,
  isAgent,
  setUserInfo,
  config,
  globalData,
  style,
  boolForWeChatH5,
  getRealUrl,
  getWechatUserAuth
}

App.mpType = 'app'

const app = new Vue({
  ...App
})
app.$mount()